module.exports = __webpack_public_path__ + "static/img/paiban.6f28e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/paiban.png
// module id = ZYK4
// module chunks = 1